import { Security } from '@okta/okta-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import { FeatureFlagProvider } from '@/contexts/FeatureFlagContext';
import { OrganizationProvider } from '@/contexts/OrganizationContext';
import { oktaAuth, restoreOriginalUri } from '@/lib/auth';
import { queryClient } from '@/lib/query-client-config';
import { AuthProvider } from '@/providers/AuthProvider';
import { AppRouter } from './router/AppRouter';

const App = () => {
  return (
    <div className="flex h-screen flex-col">
      <div className="flex-1 overflow-hidden">
        <QueryClientProvider client={queryClient}>
          <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <AuthProvider>
              <OrganizationProvider>
                <FeatureFlagProvider>
                  <AppRouter />
                </FeatureFlagProvider>
              </OrganizationProvider>
            </AuthProvider>
          </Security>
          <Toaster position="bottom-right" richColors />
        </QueryClientProvider>
      </div>
    </div>
  );
};

export default App;
